import React from 'react';

const Footer = () => {
    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <footer className="footer">
            <div className="footer__container container grid">
                <ul className="footer__links">
                    <li><button className="footer__link" onClick={() => scrollTo('projects')}>Work</button></li>
                    <li><button className="footer__link" onClick={() => scrollTo('experience')}>Experience</button></li>
                    <li><button className="footer__link" onClick={() => scrollTo('skills')}>Expertise</button></li>
                    <li><button className="footer__link" onClick={() => scrollTo('about')}>About</button></li>
                    <li><button className="footer__link" onClick={() => scrollTo('contact')}>Contact</button></li>
                </ul>

                <span className="footer__copy">
                    © {new Date().getFullYear()} ·{' '}
                    <span className="footer__copy-name">Haider Masood</span>
                    <span className="footer__copy-role"> · AI Engineer &amp; Team Lead</span>
                </span>
            </div>
        </footer>
    );
};

export default Footer;
